export default __webpack_public_path__ + "static/media/AnnotateImaging.46aec2a0.svg";